import client from 'utils/contentfulService';
import { DATE_FORMAT } from 'utils/constants';
import _get from 'lodash/get';
import { format } from 'date-fns';

const getHomeClientList = async (key, clientId, localeFilters) => {
  try {
    const now = Date.now();
    const ctfPayload = {
      content_type: 'clientList',
      'fields.client.sys.id': clientId,
      'fields.reviewStatus': 'Accepted',
      'fields.promotionDate[lte]': format(now, DATE_FORMAT),
      'fields.promotionEndDate[gte]': format(now, DATE_FORMAT),
      order: '-fields.order',
      include: 2,
      ...localeFilters,
    };
    const response = await client.getEntries(ctfPayload);
    const items = _get(response, 'items', []);
    const prettyData = [];
    items.forEach(item => {
      const {
        fields: {
          displaySection,
          order,
          promotionDate,
          promotionEndDate,
          list,
        },
      } = item;
      prettyData.push({
        ..._get(list, '0', {}),
        displaySection,
        order,
        clientPromotionDate: promotionDate,
        clientPromotionEndDate: promotionEndDate,
      });
    });
    return prettyData;
  } catch (error) {
    throw new Error(error);
  }
};

export default getHomeClientList;
